import { render, staticRenderFns } from "./AppointView.vue?vue&type=template&id=0ff8bfcf&scoped=true"
import script from "./AppointView.vue?vue&type=script&lang=js"
export * from "./AppointView.vue?vue&type=script&lang=js"
import style0 from "./AppointView.vue?vue&type=style&index=0&id=0ff8bfcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff8bfcf",
  null
  
)

export default component.exports